import { create } from "@storybook/theming/create";

export default create({
	base: "light",
	brandTitle: "Niteco Components UI",
	brandUrl: "/",
	brandImage: "images/niteco-logo.svg",
	brandTarget: "_self",
});
